import React, { useState } from "react";
import Book from "../ui/Book";
import { books } from "../../../data";

const Books = () => {
  const [sortBy, setSortBy] = useState("DEFAULT");
  const sortedBooks = [...books].sort((firstBook, secondBook) => {
    const firstPrice = firstBook.salePrice ?? firstBook.originalPrice;
    const secondPrice = secondBook.salePrice ?? secondBook.originalPrice;

    if (sortBy === "LOW-TO-HIGH") return firstPrice - secondPrice;
    if (sortBy === "HIGH-TO-LOW") return secondPrice - firstPrice;
    if (sortBy === "RATING") return secondBook.rating - firstBook.rating;
    return 0;
  });

  return (
    <div id="books__body">
      <main id="books__main">
        <section>
          <div className="books__container">
            <div className="row">
              <div className="books__header">
                <h1 className="section__title books__header--title">
                  All Books
                </h1>
                <select
                  id="filter"
                  value={sortBy}
                  onChange={(event) => setSortBy(event.target.value)}
                >
                  <option value="DEFAULT" disabled>
                    Sort
                  </option>
                  <option value="LOW-TO-HIGH">Price Low to High</option>
                  <option value="HIGH-TO-LOW">Price High to Low</option>
                  <option value="RATING">Rating</option>
                </select>
              </div>
              <div className="books">
                {sortedBooks.map((book) => (
                  <Book
                    key={book.id}
                    id={book.id}
                    imgSrc={book.url}
                    title={book.title}
                    rating={book.rating}
                    normalPrice={book.originalPrice}
                    salePrice={book.salePrice}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Books;
